import React from "react";
import CountdownTimer from "../CountDown/CountDown";
import Mail from "./Mail";
import shape01 from "../../assets/img/banner/banner_shape01.png";
import CapRangeSlider from "../Progress/Progress";
import { Link } from "react-router-dom";

const Banner = () => {
  return (
    <section className="banner-area banner-bg">
      <div className="mx-3 mx-md-0">
        <div className="row">
          <div className="hero-container d-lg-flex justify-content-lg-around">
            {/* Left Section */}
            <div className="left-content col-lg-6">
              <div className="banner-text section-title">
                <h1 className="title">
                  Join the <span>Health Revolution</span> with DIAG Token & AI
                  Care
                </h1>
                <p className="merriweather-sans mt-5 mb-5">
                  Diagnose Smarter. Live Better. Invest in the Future of Care.
                </p>

                <div className="pb-4 d-flex flex-column flex-md-row align-items-start gap-3">
                  <Mail />
                  <Link to="/presale" className="btn">
                    Join Presale Now
                  </Link>
                </div>

                <div className="announcement-wrapper d-lg-flex mt-4 align-items-lg-end">
                  <div>
                    <h6 className="mb-3">Announcement</h6>
                    <p className="merriweather-sans">
                      The Future of Healthcare is Here – Powered by Blockchain
                    </p>
                    <p className="merriweather-sans">
                      We are excited to introduce MediToken – the revolutionary
                      cryptocurrency built
                    </p>
                  </div>
                  <div>
                    <img src={shape01} alt="Shape" className="img-one" />
                  </div>
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div className="right-content col-lg-5">
              <div className="token-price merriweather-sans">
                <h5>DIAG Token Price</h5>
                <p>1 DIAG = 0.01 USDT</p>
              </div>
              <div className="d-flex justify-content-between merriweather-sans">
                <div>
                  <p className="mb-0">Current Bonus</p>
                  <p>05 %</p>
                </div>
                <div>
                  <p>
                    End At <br />
                    10 Jan, 2026
                  </p>
                </div>
              </div>
              <div>
                <CapRangeSlider />
              </div>
              <p
                style={{ borderStyle: "dotted none none none" }}
                className="mt-3"
              ></p>
              <CountdownTimer />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
